// extracted by mini-css-extract-plugin
var _1 = "GalleryHeader-moduleGalleryHeader__wis1n";
var _2 = "GalleryHeader-modulefileIcon__Tyjkb FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
var _3 = "GalleryHeader-modulefileName__avy_c";
var _4 = "GalleryHeader-moduleiconTool__tgDRa";
var _5 = "GalleryHeader-moduleleftTools__fpe90";
var _6 = "GalleryHeader-modulerightTools__dUJIJ";
var _7 = "GalleryHeader-moduletitle__k2pZM";
export { _1 as "GalleryHeader", _2 as "fileIcon", _3 as "fileName", _4 as "iconTool", _5 as "leftTools", _6 as "rightTools", _7 as "title" }
